import { type ReactElement } from 'react'

import { useGetCurrentUser } from '@lib/hooks/user'
import { CurrentUserContextProvider } from '@lib/services/user/context'

export function withCurrentUser<T extends Record<string, any>>(
  Component: (props: T) => ReactElement,
): (props: T) => ReactElement {
  return pageProps => {
    const currentUser = useGetCurrentUser()

    return (
      <CurrentUserContextProvider value={currentUser}>
        <Component {...pageProps} />
      </CurrentUserContextProvider>
    )
  }
}
